// 封装过期控制代码
export const setStorage = (key, value) => {
  var curTime = new Date().getTime()
  window.localStorage.setItem(
    key,
    JSON.stringify({
      data: value,
      time: curTime,
    }),
  )
}
export const getStorage = (key, exp = 86400) => {
  var data = window.localStorage.getItem(key)
  var dataObj = JSON.parse(data)
  if (!dataObj || (new Date().getTime() - dataObj.time) / 1000 > exp) {
    console.log('信息已过期, 请重新登录')
    window.localStorage.removeItem(key)
  } else {
    return JSON.parse(dataObj.data)
  }
}

export const removeStorage = key => {
  window.localStorage.removeItem(key)
}
